import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { trackPageVisit } from '../../services/activityTracker';

/**
 * Component that tracks page visits on route changes.
 * Place inside <Router> and <AuthProvider>.
 */
const RouteTracker: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;

    // Map paths to readable page names
    const pageNames: Record<string, string> = {
      // Customer pages
      '/customer-dashboard': 'Dashboard',
      '/products': 'Product Catalog',
      '/cart': 'Shopping Cart',
      '/orders': 'Order History',
      '/reports': 'Financial Reports',
      // Company pages
      '/company/dashboard': 'Company Dashboard',
      '/company/customers': 'Company Customers',
      '/company/orders': 'Company Orders',
      '/company/settings': 'Company Settings',
      '/company/products': 'Company Products',
      '/company/tomorrows-bake': 'Tomorrow\'s Bake',
      '/company/support': 'Company Support Tickets',
      '/company/support/new': 'New Support Ticket',
      // Admin pages
      '/manage/settings': 'Admin SEO Settings',
      '/manage/activity-logs': 'Admin Activity Logs',
      '/manage/security-events': 'Admin Security Events',
      '/manage/support': 'Admin Support Tickets',
      '/manage/email-templates': 'Admin Email Templates',
    };

    const path = location.pathname;
    let pageName = pageNames[path];

    // Handle dynamic routes
    if (!pageName) {
      if (path.startsWith('/company/customers/')) {
        pageName = 'Customer Detail';
      } else if (path.startsWith('/company/support/')) {
        pageName = 'Support Ticket Detail';
      } else if (path.startsWith('/manage/support/')) {
        pageName = 'Admin Ticket Detail';
      } else if (path.startsWith('/orders/')) {
        pageName = 'Order Details';
      } else if (path.startsWith('/products/')) {
        pageName = 'Product Details';
      }
    }

    if (pageName) {
      trackPageVisit(path, pageName);
    }
  }, [location.pathname, isAuthenticated]);

  return null;
};

export default RouteTracker;
